import React, { useEffect, useState } from "react";
import "./personality.css";

import beforesunrise from "../../movies/amorosa/beforesunrise.jpg";
import casablanca from "../../movies/amorosa/casablanca.jpg";
import inthemoodforlove from "../../movies/amorosa/inthemoodforlove.jpg";
import littlefish from "../../movies/amorosa/littlefish.jpg";
import neverletmego from "../../movies/amorosa/neverletmego.jpg";
import orgulloyprejuicio from "../../movies/amorosa/orgulloyprejuicio.jpg";
import paristexas from "../../movies/amorosa/paristexas.jpg";
import romanholiday from "../../movies/amorosa/romanholiday.jpg";
import thenotebook from "../../movies/amorosa/thenotebook.jpg";
import pastlives from "../../movies/amorosa/pastlives.jpg";

const movies = [
  {
    title: "Before Sunrise",
    image: beforesunrise,
    director: "Richard Linklater",
    year: 1995,
    cast: "Ethan Hawke, Julie Delpy",
    synopsis:
      "Dos jóvenes se conocen en un tren y pasan una noche caminando por Viena explorando la conexión entre ellos."
  },
  {
    title: "Casablanca",
    image: casablanca,
    director: "Michael Curtiz",
    year: 1942,
    cast: "Humphrey Bogart, Ingrid Bergman",
    synopsis:
      "Durante la Segunda Guerra Mundial, el dueño de un café en Casablanca se reencuentra con un amor de su pasado entre intrigas y exilios."
  },
  {
    title: "In the Mood for Love",
    image: inthemoodforlove,
    director: "Wong Kar-wai",
    year: 2000,
    cast: "Tony Leung, Maggie Cheung",
    synopsis:
      "Un hombre y una mujer sospechan que sus parejas les son infieles y lentamente desarrollan una conexión silenciosa y profunda."
  },
  {
    title: "Little Fish",
    image: littlefish,
    director: "Rowan Woods",
    year: 2005,
    cast: "Cate Blanchett, Hugo Weaving, Sam Neill",
    synopsis:
      "Una mujer limpia de heroína desde hace cuatro años lucha por abrir su propio negocio mientras su pasado la acecha."
  },
  {
    title: "Never Let Me Go",
    image: neverletmego,
    director: "Mark Romanek",
    year: 2010,
    cast: "Carey Mulligan, Keira Knightley, Andrew Garfield",
    synopsis:
      "Amistad, amor y destino trágico en un mundo distópico donde los seres humanos nacen para donar órganos."
  },
  {
    title: "Orgullo y Prejuicio",
    image: orgulloyprejuicio,
    director: "Joe Wright",
    year: 2005,
    cast: "Keira Knightley, Matthew Macfadyen",
    synopsis:
      "Una apasionada adaptación del clásico de Jane Austen donde Elizabeth Bennet y el señor Darcy deben superar sus prejuicios y orgullo."
  },
  {
    title: "Paris, Texas",
    image: paristexas,
    director: "Wim Wenders",
    year: 1984,
    cast: "Harry Dean Stanton, Nastassja Kinski",
    synopsis:
      "Un hombre reaparece años después para buscar reconectar con su hijo y su exesposa, explorando el sentido del hogar y la memoria."
  },
  {
    title: "Roman Holiday",
    image: romanholiday,
    director: "William Wyler",
    year: 1953,
    cast: "Audrey Hepburn, Gregory Peck",
    synopsis:
      "Una princesa escapa de sus obligaciones y conoce Roma con un periodista americano, viviendo una noche de libertad y romance."
  },
  {
    title: "The Notebook",
    image: thenotebook,
    director: "Nick Cassavetes",
    year: 2004,
    cast: "Ryan Gosling, Rachel McAdams",
    synopsis:
      "Un hombre lee la historia de un amor vivido décadas atrás para revelarle a su esposa los recuerdos que comparten."
  },
  {
    title: "Past Lives",
    image: pastlives,
    director: "Celine Song",
    year: 2023,
    cast: "Greta Lee, Teo Yoo",
    synopsis:
      "Dos amigos de infancia se reencuentran después de muchos años y reflexionan sobre el destino, el amor y el paso del tiempo."
  }
];

// ⭐⭐⭐⭐⭐ Letterboxd-style SVGs
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Amorosa() {
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies") || "{}")
  );
  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings") || "{}")
  );

  useEffect(() => window.scrollTo(0, 0), []);

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMovies", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Amorosa</h1>
      <p>
        Las personas que no llegan a conocerte pueden tender a pensar que sos una persona poco amorosa...
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Amorosa;




